import { Box, CircularProgress, Stack, Typography } from '@mui/material';

import { selectExternalFormCompletion } from '@/domain/external/external.selectors';
import { FSPrimaryButton } from '@/ui/components/button/FSPrimaryButton';
import { useAppSelector } from '@/ui/hook/store';
import { translate } from '@/ui/i18n';
import { ColorsRaw } from '@/ui/theme/colors-raw';

interface Props {
  disableValidate?: boolean;
  onClickValidate: () => void;
}

export function FooterSticky({
  disableValidate,
  onClickValidate: onClickValidate,
}: Props) {
  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 1, // fix input label that goes above
      }}
    >
      <Footer
        disableValidate={disableValidate}
        onClickValidate={onClickValidate}
      />
    </Box>
  );
}

function Footer({
  disableValidate,
  onClickValidate: onClickValidateAllForm,
}: Props) {
  return (
    <Box
      sx={{
        backgroundColor: ColorsRaw.anthracite.Anthracite_1,
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        p: 3,
        borderTop: `1px solid ${ColorsRaw.anthracite.Anthracite_4}`,
      }}
    >
      <Stack direction={'row'} alignItems={'center'}>
        <GlobalProgression />
        <FSPrimaryButton
          disabled={disableValidate}
          onClick={onClickValidateAllForm}
        >
          {translate('External.validate-form')}
        </FSPrimaryButton>
      </Stack>
    </Box>
  );
}

function GlobalProgression() {
  const progression = useAppSelector(selectExternalFormCompletion);
  return (
    <Stack direction={'row'} alignItems={'center'} sx={{ mr: 4 }}>
      <CircularProgress
        size={18}
        variant="determinate"
        value={Math.floor(progression * 100)}
      />
      <Box sx={{ ml: 1.5 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 'bold' }}>
          {Math.floor(progression * 100)}% {translate('Projects.completed')}
        </Typography>
      </Box>
    </Stack>
  );
}
